import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29e32222")

_pushScopeId("data-v-29e32222")
const _hoisted_1 = { class: "shell" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsData, (item) => {
      return (_openBlock(), _createBlock(_component_cus_button, {
        class: "button-tab",
        key: item.name,
        onClick: ($event: any) => (_ctx.changeActiveName(item.name)),
        type: _ctx.activeName===item.name?'blue':'default'
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(item.label), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "type"]))
    }), 128)),
    _createVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabsData[_ctx.activeName].component), {
        type: _ctx.type,
        deviceType: _ctx.deviceType
      }, null, 8, ["type", "deviceType"]))
    ])
  ]))
})